import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const location = useLocation();
  const { pathname, search } = location;

useLayoutEffect(() => {
    // Désactive le comportement natif "je reviens où j'étais"
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    const targets = [window, document.scrollingElement, document.documentElement, document.body];

    targets.forEach((target) => {
      if (!target) return;
      try { target.scrollTo({ top: 0, left: 0, behavior: "instant" }); } catch { /* noop */ }
      if (target !== window) target.scrollTop = 0;
    });
  }, [pathname, search]); // se déclenche sur chaque changement d'URL

  return null;
}